import { render, staticRenderFns } from "./CouponPayBack.vue?vue&type=template&id=488b7b96&"
import script from "./CouponPayBack.vue?vue&type=script&lang=ts&"
export * from "./CouponPayBack.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports